import { render, staticRenderFns } from "./SimpleChoiceDialog.vue?vue&type=template&id=c4dc66cc&scoped=true"
import script from "./SimpleChoiceDialog.vue?vue&type=script&lang=js"
export * from "./SimpleChoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./SimpleChoiceDialog.vue?vue&type=style&index=0&id=c4dc66cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dc66cc",
  null
  
)

export default component.exports